import { LoiForm } from './loi-form';
import { TermFormFieldComment } from './term-form-field-comment';

export interface FairValueField {
    fairValue: number | null;
    fairValueExplanation: string | null;
}

export interface LoiFormFairValues {
    cashAtClose: FairValueField | null;
    workingCapitalHoldback: FairValueField | null;
    deferredFixedPaymentRows: (FairValueField | null)[];
    deferredVariablePaymentRows: (FairValueField | null)[];
    jvEquityRow: FairValueField | null;
    corporateEquityRows: (FairValueField | null)[];
    other: FairValueField | null;
    adminComments: TermFormFieldComment[];
}

function field(fairValue?: number | null, fairValueExplanation?: string | null): FairValueField {
    return {
        fairValue: fairValue ?? null,
        fairValueExplanation: fairValueExplanation ?? null,
    };
}

export function buildLoiFormFairValues(formData: LoiForm): LoiFormFairValues {
    const summary = formData.termForm?.purchasePriceSummary;
    const cashAtCloser = summary?.cashAtCloser;
    const wch = cashAtCloser?.workingCapitalHoldback;
    const jvRow = summary?.jvEquity?.row;
    return {
        cashAtClose: field(cashAtCloser?.fairValue, cashAtCloser?.fairValueExplanation),
        workingCapitalHoldback: field(wch?.fairValue, wch?.fairValueExplanation),
        deferredFixedPaymentRows: (summary?.deferredFixedPayments?.rows ?? []).map((r) =>
            field(r.fairValue, r.fairValueExplanation)
        ),
        deferredVariablePaymentRows: (summary?.deferredVariablePayments?.rows ?? []).map((r) =>
            field(r.fairValue, r.fairValueExplanation)
        ),
        jvEquityRow: jvRow ? field(jvRow.fairValue, jvRow.fairValueExplanation) : null,
        corporateEquityRows: (summary?.corporateEquity?.rows ?? []).map((r) =>
            field(r.fairValue, r.fairValueExplanation)
        ),
        other: field(summary?.otherFairValue, summary?.otherFairValueExplanation),
        adminComments: formData.termForm?.fieldComments ?? [],
    };
}
